import { Moment } from 'moment'

/** A helper, thats used in the time/date-picker rhf-component, that still works with 'moment' and needs to be transformed to a date */
export const transformDateInput = (date: Moment | null): Date | null => date?.toDate() ?? null
